import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import LockerManagement from '../page/LockerManagement';



class LockerManagementPortal extends Component {
  render() {

    let isLockerEnabled: boolean;
    let orgId: number;
    let isOrgAdmin: boolean ;
    // Container ref
    let targetContainer = document.getElementById('react-locker-management-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }
    else {
      isLockerEnabled = targetContainer.getAttribute('data-lockerEnabled') === 'True' ? true : false;
      isOrgAdmin = targetContainer.getAttribute('data-isOrgAdmin') === 'True' ? true : false;
      orgId = +targetContainer.getAttribute('data-orgId')
    }

    return ReactDOM.createPortal( 
      <LockerManagement isLockerEnabled={isLockerEnabled} orgId={orgId} isOrgAdmin={isOrgAdmin}/>
      , targetContainer
    );
  }
}

export default LockerManagementPortal;